export enum Colors{
    RED='#FE0002',
    BLUE='#0100FE',
    GREEN='#009F00',
    ORANGE='#FF9A00',
    YELLOW='#FFFF01',
    PINK='#EFD2D8',
    PURPLE='#980086',
    VIOLET='#B4CACD',
    VIOLET_TINT='#6C797B',
    TRUQUDISE='#00E1D1',
    GOLD='#FFD701',
    LIME='#02FF02',
    AQUA='#01FFFF',
    NAVY='#545DA2',
    CORA='#FF7D4B',
    TRAL='#018184',
    BROWN='#C12528',
    BROWN_TINT="#CD5052",
    WHITE='#FFFFFF',
    BLOCK='#000000',

    UNDEAL='#00A6FF',
    REJECTED='#F7BBC2',
    WEIGHT_CAPTURED='#E5D67F',
    COMPLETED='#AECE12',
    INBOUND_SCAN='#AECE13',
    PENDING='#FFD185',
    TOTAL_INBOUND_CONS='#CE8813'
}